import { Box, type SxProps, type Theme } from '@mui/material';
import { PRODUCT_BRAND } from '@/config/productBrand';

/**
 * Which artwork to render.
 *
 * `wordmark` is the full logo, whose text is WHITE — it only reads on a dark surface. `icon` is the
 * mark alone and is safe anywhere, so it is the right choice on cards, light panels and anywhere the
 * background colour is not guaranteed.
 */
type ProductLogoVariant = 'wordmark' | 'icon';

interface Props {
  width?: number;
  variant?: ProductLogoVariant;
  sx?: SxProps<Theme>;
}

/** The official GoERP product logo. Single source for the asset paths — reuse this component
 *  instead of hardcoding image paths. (Tenant logos keep using BrandLogo.) */
export default function ProductLogo({ width = 100, variant = 'wordmark', sx }: Props) {
  return (
    <Box
      component="img"
      src={variant === 'icon' ? PRODUCT_BRAND.icon : PRODUCT_BRAND.logo}
      alt={PRODUCT_BRAND.legalName}
      sx={{ width, height: 'auto', display: 'block', ...sx }}
    />
  );
}
